import React, { useEffect, useRef } from "react";

const Score = ({ score, total, onRetry }) => {

  const starsRef = useRef([]);

  useEffect(() => {
    if (starsRef.current.length === 0) return;
  
    starsRef.current.forEach((star, index) => {
      setTimeout(() => {
        if (star) {
          if (index < score) {
            star.classList.add('up');
          } else {
            star.classList.add('down');
          }
        }
      }, index * 600); // 0.6s between each
    });
  }, [score]);

  return (
    <div className="app">
      <div className="bg">
        <div className="bg-panel"></div>
        <div className="bg-panel"></div>
        <div className="bg-panel"></div>
      </div>
      <div className="end-screen">
          <h2>
            {score <= 2
              ? "Estás quase lá..."
              : score === 3
              ? "Foi por pouco!"
              : score === 4
              ? "Boa! Conseguiste!"
              : "Parabéns! Foste Excelente!"}
          </h2>
          <p>
            {score <= 2
              ? "Tenta novamente para melhorares o teu resultado"
              : "Obrigado por participares"}
          </p>
          <div className="stars">
            {[...Array(total)].map((_, index) => (
              <span
                key={index}
                className="star"
                ref={el => (starsRef.current[index] = el)}
              >
                <object type="image/svg+xml" data="/assets/images/star.svg" aria-label="star"></object>
              </span>
            ))}
          </div>
          <div className="button-group">
            {score <= 2 && (
              <button className="try-again" onClick={() => {
                localStorage.setItem("allowResume", "true");
                onRetry("retry");
              }}>tentar novamente</button>
            )}
            <button onClick={() => onRetry("exit")}>sair</button>
          </div>
        </div>
    </div>
  );
};

export default Score;
